var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"-1px","border-bottom":"1px solid rgba(0, 0, 0, 0.12)"}},[_c('JobsTreeOrganizations',{attrs:{"jobs":_vm.jobs,"onArchiveJob":_vm.onArchiveJob,"unfold":_vm.unfold}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }